import { render, staticRenderFns } from "./CuratorAndTeacherMainPanel.vue?vue&type=template&id=508ec633&scoped=true&"
import script from "./CuratorAndTeacherMainPanel.vue?vue&type=script&lang=js&"
export * from "./CuratorAndTeacherMainPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508ec633",
  null
  
)

export default component.exports